import React from 'react'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import { Box, InputAdornment, Link, TextField, Theme } from '@mui/material'

import { makeStyles } from '@mui/styles'

interface ISearchInputData {
  value?: string
  onChangeValue?: (value: string) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  accountSearch: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  textField: {
    height: 'auto',
  },
  clearIcon: {
    paddingTop: theme.spacing(0.5),
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

const SearchInput: React.FC<ISearchInputData> = (props) => {
  const classes = useStyles()

  return (
    <TextField
      className={classes.textField}
      value={props.value}
      id='search'
      label='Suchen'
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <Box display='flex' alignItems='center'>
              {!props.value ? <SearchIcon />
                : (
                  <Link onClick={() => props.onChangeValue && props.onChangeValue('')}>
                    <ClearIcon
                      className={classes.clearIcon}
                    />
                  </Link>
                )}
            </Box>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(event) => props.onChangeValue && props.onChangeValue(event.target.value)}
      margin='none'
      size='small'
      variant='outlined'
      fullWidth
    />
  )
}
export default SearchInput
